export enum SubmoduleType {
  Video = 'video',
  Text = 'text',
  Slide = 'slide',
  Test = 'test',
  Project = 'project',
}
